import { GET_ALL_PHYSICALLYCHALLENGE_CATEGORY } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_PHYSICALLYCHALLENGE_CATEGORY:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getAllPhysicallyChallengeCategory.js